import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Page from 'flarum/common/components/Page';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';

/*
 * Matomo page views for in-Forum navigation (2026-10-29; the tracker itself comes from SiteAnalytics.php).
 * Every Forum page (index, tag, discussion, user, categories) is a Page component, and Flarum's route resolvers
 * build a new one only on a real page change: the URL rewrites made while scrolling a discussion keep the same
 * component (DiscussionPageResolver.makeKey drops `near`). So one page view per Page.oncreate, skipping the first,
 * which the partial's own trackPageView already counted. No-op when _paq is absent (localhost gate).
 * A discussion's title is set only in DiscussionPage.show(), once its data has loaded (often after oncreate), so
 * its page view waits for show(). The title is built from app.title, not read from document.title: during a page
 * change Flarum's updateTitle() still sees the old route and briefly writes the bare Forum name.
 */
let firstPage = true;
let lastUrl = document.location.href;

function trackPageView() {
  const paq = window._paq;
  const gtag = window.gtag;
  if (!paq && typeof gtag !== 'function') return;
  const url = document.location.href;
  const forumName = app.forum.attribute('title');
  const home = document.location.pathname.replace(/\/$/, '') === app.forum.attribute('basePath');
  const title = home || !app.title ? forumName : `${app.title} - ${forumName}`;
  if (paq) {
    paq.push(['setReferrerUrl', lastUrl]);
    paq.push(['setCustomUrl', url]);
    paq.push(['setDocumentTitle', title]);
    paq.push(['trackPageView']);
  }
  // GA4 (2026-10-29): the same page views. Relies on the web stream's "Page changes based on browser history
  // events" being off; left on, GA4 also counts every scroll URL rewrite, with the previous page's title.
  if (typeof gtag === 'function') {
    gtag('event', 'page_view', { page_location: url, page_title: title, page_referrer: lastUrl });
  }
  lastUrl = url;
}

export default function installAnalytics() {
  extend(Page.prototype, 'oncreate', function () {
    if (firstPage) {
      firstPage = false;
      return;
    }
    if (this instanceof DiscussionPage && !this.citregShown) {
      this.citregTrackPending = true;
      return;
    }
    // Other pages set their title during oninit/oncreate; read it once this redraw is done.
    setTimeout(trackPageView, 0);
  });

  extend(DiscussionPage.prototype, 'show', function () {
    this.citregShown = true;
    if (this.citregTrackPending) {
      this.citregTrackPending = false;
      trackPageView();
    }
  });
}
